import { t } from 'localization/utils/t';

const TP = 'productTemplate.utils.boxConditionDataMap';

export const getBoxConditionCopy = (condition) => {
  switch (condition) {
    case 'badly_damaged':
      return t(`${TP}.damagedBox`, 'New / Damaged Box');

    case 'good_condition':
      return t(`${TP}.goodCondition`, 'New / Good Condition');

    case 'missing_lid':
      return t(`${TP}.missingLid`, 'New / Missing Lid');

    case 'no_original_box':
      return t(`${TP}.noOriginalBox`, 'New / No Original Box');

    default:
      return '';
  }
};
